// Registry of the pages that hold edits the user has not saved. Two things ask it: the browser (a
// reload, a closed tab, a typed URL — `beforeunload`) and the app itself, before it reloads the page
// on purpose (an asset-class switch).

const checkers = new Set()
let allowed = false

function onBeforeUnload(event) {
  if (allowed || !hasUnsavedChanges()) {
    return
  }
  // The text is ignored by browsers, which show their own; setting returnValue is what triggers it.
  event.preventDefault()
  event.returnValue = ''
}

// `check()` answers whether the page has unsaved changes. Returns the function that unregisters it.
export function registerUnsavedChanges(check) {
  if (checkers.size === 0) {
    window.addEventListener('beforeunload', onBeforeUnload)
  }
  checkers.add(check)

  return () => {
    checkers.delete(check)
    if (checkers.size === 0) {
      window.removeEventListener('beforeunload', onBeforeUnload)
    }
  }
}

export function hasUnsavedChanges() {
  return [...checkers].some((check) => {
    try {
      return check() === true
    } catch {
      // Losing the warning is better than blocking the user with a page that cannot answer.
      return false
    }
  })
}

// Resolves true when the app may go on (nothing to lose, or the user accepted losing it), and lets
// the reload that follows through without a second, browser-made question.
export async function confirmDiscardUnsavedChanges(vm) {
  if (!hasUnsavedChanges()) {
    return true
  }

  const confirmed = await vm.$bvModal.msgBoxConfirm(vm.$t('navbar.assetClass.unsavedChanges.message'), {
    title: vm.$t('navbar.assetClass.unsavedChanges.title'),
    okTitle: vm.$t('common.yes'),
    cancelTitle: vm.$t('common.no'),
  })
  allowed = confirmed === true
  return allowed
}

// The values of `keys` in a store module state, as a plain object comparable with JSON.stringify.
export function pickState(state, keys) {
  return keys.reduce((picked, key) => ({ ...picked, [key]: state[key] }), {})
}
